module.exports = __webpack_public_path__ + "img/Katarina_home_09.03e97184.jpg";